import type { DefaultContext } from '@apollo/client';

import {
  useSendInvitesToConsumersByCvStaffMutation,
  useSendInvitesToConsumersByEmployerMutation,
  useSendInvitesToConsumersByPeoMutation,
  useSendInvitesToConsumersByPeoPayrollProviderMutation,
} from 'src/api';

export type InviteMutationScope = 'employer' | 'peo' | 'peoPayrollProvider' | 'cvStaff';

/**
 * Resolves the invite mutation matching the caller's scope. Shared by the send
 * and resend hooks, which only differ in messaging and call semantics.
 */
export const useScopedInviteMutation = (scope: InviteMutationScope, context: DefaultContext) => {
  const [byEmployer] = useSendInvitesToConsumersByEmployerMutation({ context });
  const [byPeo] = useSendInvitesToConsumersByPeoMutation({ context });
  const [byPeoPayrollProvider] = useSendInvitesToConsumersByPeoPayrollProviderMutation({ context });
  const [byCVStaff] = useSendInvitesToConsumersByCvStaffMutation({ context });

  return {
    employer: byEmployer,
    peo: byPeo,
    peoPayrollProvider: byPeoPayrollProvider,
    cvStaff: byCVStaff,
  }[scope];
};
